<template>
<div v-if="visible" class="vue-drag-select-box" :style="selectionBoxStyling"></div>
</template>

<script>
import { forEach, isEmpty } from 'lodash';

import DashboardConst from '@/constants/dashboard';
import Base from '@/mixins/dashboard/base';

export default {
  name: 'WDragSelect',
  mixins: [Base],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mouseDown: false,
      startPoint: null,
      endPoint: null,
    };
  },
  inject: {
    layoutData: {
      default: () => {},
    },
  },
  computed: {
    visible() {
      return !this.disabled && this.isEditMode && this.editSelectMode === DashboardConst.EDIT_SELECT_MODE.SELECTION && this.mouseDown;
    },
    selectionBox() {
      // Only set styling when necessary
      if (!this.mouseDown || !this.startPoint || !this.endPoint) return {};

      const clientRect = this.$parent.$el.getBoundingClientRect();
      const scroll = this.getScroll();

      // Calculate position and dimensions of the selection box
      const left = Math.min(this.startPoint.x, this.endPoint.x) - clientRect.left - scroll.x;
      const top = Math.min(this.startPoint.y, this.endPoint.y) - clientRect.top - scroll.y;
      const width = Math.abs(this.startPoint.x - this.endPoint.x);
      const height = Math.abs(this.startPoint.y - this.endPoint.y);

      // Return the styles to be applied
      return {
        left,
        top,
        width,
        height,
      };
    },
    selectionBoxStyling() {
      // Only set styling when necessary
      if (!this.mouseDown || !this.startPoint || !this.endPoint) return {};

      const { left, top, width, height } = this.selectionBox;

      // Return the styles to be applied
      return {
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
      };
    },
  },
  methods: {
    getScroll() {
      // If we're on the server, default to 0,0
      if (typeof document === 'undefined') {
        return {
          x: 0,
          y: 0,
        };
      }

      return {
        x: (document.body.scrollLeft || document.documentElement.scrollLeft || 0) - this.$parent.$el.scrollLeft || 0,
        y: (document.body.scrollTop || document.documentElement.scrollTop || 0) - this.$parent.$el.scrollTop || 0,
      };
    },
    onMouseDown(event) {
      // Ignore right clicks
      if (event.button === 2) return;

      // Register begin point
      this.mouseDown = true;
      this.startPoint = {
        x: event.pageX,
        y: event.pageY,
      };
    },
    onMouseMove(event) {
      // Update the end point position
      if (this.mouseDown) {
        this.endPoint = {
          x: event.pageX,
          y: event.pageY,
        };
      }
    },
    onMouseUp() {
      if (!this.disabled && this.mouseDown && this.startPoint && this.endPoint) {
        this.isItemSelected();
      }

      // Reset state
      this.mouseDown = false;
      this.startPoint = null;
      this.endPoint = null;
    },
    isItemSelected() {
      if (!isEmpty(this.widgetLayout)) {
        const { dashboardScale, dashboardScaleX, dashboardScaleY, isFullScale } = this.layoutData;
        const offsetX = isFullScale ? dashboardScaleX : dashboardScale;
        const offsetY = isFullScale ? dashboardScaleY : dashboardScale;

        const boxA = this.selectionBox;

        forEach(this.widgetLayout, (widget) => {
          if (this.widgetVisible(widget)) {
            const boxB = {
              top: widget.y * offsetY,
              left: widget.x * offsetX,
              width: widget.w * offsetX,
              height: widget.h * offsetX,
            };

            // 영역에 걸치기만 해도 선택 되는 조건
            // const active = !!(boxA.left <= boxB.left + boxB.width && boxA.left + boxA.width >= boxB.left && boxA.top <= boxB.top + boxB.height && boxA.top + boxA.height >= boxB.top);

            // 영역안에 완전히 들어와야 선택 되는 조건
            const active = !!(boxA.left < boxB.left && boxA.left + boxA.width > boxB.left + boxB.width && boxA.top < boxB.top && boxA.top + boxA.height > boxB.top + boxB.height);

            this.$set(widget, 'active', active);
          }
        });
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.WIDGET_ACTIVE_CHANGE);
      }
    },
  },
  mounted() {
    this.$parent.$el.addEventListener('mousedown', this.onMouseDown);

    window.addEventListener('mouseup', this.onMouseUp);
    window.addEventListener('mousemove', this.onMouseMove);
  },
  beforeDestroy() {
    // Remove event listeners
    this.$parent.$el.removeEventListener('mousedown', this.onMouseDown);

    window.removeEventListener('mouseup', this.onMouseUp);
    window.removeEventListener('mousemove', this.onMouseMove);
  },
};
</script>

<style>
.vue-drag-select-box {
  position: absolute;
  background: rgba(0, 162, 255, 0.4);
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/DragSelect.vue